import { render, staticRenderFns } from "./EventsNav.vue?vue&type=template&id=e6b9bb04&scoped=true&"
import script from "./EventsNav.vue?vue&type=script&lang=js&"
export * from "./EventsNav.vue?vue&type=script&lang=js&"
import style0 from "./EventsNav.vue?vue&type=style&index=0&id=e6b9bb04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b9bb04",
  null
  
)

export default component.exports